import { Component, ElementRef, Input, KeyValueDiffer, KeyValueDiffers, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { XsltService } from './xslt.service';
import { Globals } from 'projects/core/src/globals';
import { Helper } from 'projects/core/src/helper';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrl: './template-preview.component.css'
})
export class TemplatePreviewComponent implements OnInit, OnChanges {

  // Riferimento diretto all'elemento <iframe> nel template
  @ViewChild('iframeArea', { static: true }) 
  iframeArea!: ElementRef<HTMLIFrameElement>;

  private _source: any;

  @Input()
  modalWindow!:any;

  @Input()
  mode="";

  @Input()
  action="preview"; // print, download, preview

  @Input()
  source:any;

  // Differ per intercettare i cambiamenti interni dell'oggetto
  private sourceDiffer!: KeyValueDiffer<string, any>;
  private templatesDiffer!: KeyValueDiffer<string, any>;

  @Input() templates: any;

  template: any;
  zoomLevel: number = 0.50;


  templatesAvailables:any=[];


  constructor(private xsltService: XsltService,private differs: KeyValueDiffers) { }  

  ngOnInit(): void {  
   if (this.source) {
      this.sourceDiffer = this.differs.find(this.source).create();
    }
    if (this.templates) {
      this.templatesDiffer = this.differs.find(this.templates).create();
    }
  }

  // ngDoCheck viene eseguito a ogni ciclo di Change Detection
  ngDoCheck(): void {

    if (this.templates) {
      // Se il differ non era ancora stato creato (source inizialmente undefined)
      if (!this.templatesDiffer) {
        this.templatesDiffer = this.differs.find(this.templates).create();
      }
      

      // Verifica se ci sono state modifiche alle proprietà di 'source'
      const changes = this.templatesDiffer.diff(this.templates);
      if (changes) {
        this.selectTemplate();
        this.renderTemplate();
      }
    }

    if (this.source) {
      // Se il differ non era ancora stato creato (source inizialmente undefined)
      if (!this.sourceDiffer) {
        this.sourceDiffer = this.differs.find(this.source).create();
      }


      // Verifica se ci sono state modifiche alle proprietà di 'source'
      const changes = this.sourceDiffer.diff(this.source);
      if (changes) {
        if(!this.template)
          this.selectTemplate();
        this.renderTemplate();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['templates']) {
      this.selectTemplate();
      //this.renderTemplate();
    }
  
  }

  selectTemplate(): void {
    this.templatesAvailables=[];
    this.template='';
    if(Array.isArray(this.templates)){
      for(let t of this.templates){
        // verifica se è attivo
        if(t.status==1){
          //verifica se è di tipo v2
          if(t.version==2){
            //verifica se le condizioni sono rispettate
            let c=Helper.replaceKeyword(t.condition,this.source);
            if(eval(c)){              
              this.templatesAvailables.push(t);
              this.template=t;
            }
          }
        }
      }
    }

    if ( this.templatesAvailables.length>1) {
      console.log('Sono stati trovati più template validi per la condizione specificata. Verrà utilizzato il primo template valido.');
    }

    
    return undefined;
    this.template = Array.isArray(this.templates)
      ? this.templates.find((item: any) => item?.version === 2)
      : undefined;
  }

  // --- Gestione Zoom ---
  zoomIn(): void {
    if (this.zoomLevel < 2.0) {
      this.zoomLevel = parseFloat((this.zoomLevel + 0.1).toFixed(1));
      this.applyZoom();
    }
  }

  zoomOut(): void {
    if (this.zoomLevel > 0.3) {
      this.zoomLevel = parseFloat((this.zoomLevel - 0.1).toFixed(1));
      this.applyZoom();
    }
  }

  resetZoom(): void {
    this.zoomLevel = 1.0;
    this.applyZoom();
  }

  private applyZoom(): void {
  if (this.iframeArea?.nativeElement) {
    const iframe = this.iframeArea.nativeElement;
    iframe.style.transform = `scale(${this.zoomLevel})`;
    
    // Regola il margine inferiore del viewport per evitare sovrapposizioni o tagli durante lo zoom
    // const viewport = iframe.parentElement;
    // if (viewport) {
    //   const scaledHeight = iframe.offsetHeight * this.zoomLevel;
    //   viewport.style.minHeight = `${scaledHeight + 80}px`;
    // }
  }
}

  // --- Rendering XSLT e Scrittura nell'iFrame ---
  renderTemplate(): void {
  if (!this.template || !this.template.body || !this.source) {
    return;
  }

  try {

    delete this.source['referencedocument']; // Rimuove la proprietà referencedocument per evitare problemi di serializzazione

    const xmlData = this.jsonToXml({
      COMPANY: Globals.config.company,
      item: this.source
    });

    let rawHtml = this.xsltService.transform(xmlData, this.template?.body || '');

    // Stili CSS per simulare il foglio A4 e i margini di stampa
    const a4Styles = `
      <style>
        @page {
          size: A4 portrait;
          margin: 20mm; /* Margini fisici di stampa */
        }
        html, body {
          width: 100%;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }
        body {
          padding: 20mm; /* Simula i margini di stampa a schermo */
        }
        @media print {
          body {
            padding: 0; /* Rimuove il padding a schermo quando si manda in stampa */
          }
        }
      </style>
    `;
    /*
    // Inietta gli stili prima di chiudere il tag </head> (o in testa se manca)
    if (rawHtml.includes('</head>')) {
      rawHtml = rawHtml.replace('</head>', `${a4Styles}</head>`);
    } else {
      rawHtml = `${a4Styles}${rawHtml}`;
    }
  */
    const iframe = this.iframeArea.nativeElement;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(rawHtml);
      iframeDoc.close();

      // Stampa automatica se il componente è in modalità "print" e non ci sono più template disponibili
      if (this.action === 'print' && this.templatesAvailables.length==1) {
        this.action = '';
        requestAnimationFrame(() => this.printDocument());
      }

    }
  } catch (error) {
    console.error('Errore durante la trasformazione XSLT:', error);
  }
}

  /**
   * Helper generico per convertire un oggetto JS in XML
   */
  private jsonToXml(obj: any, rootName: string = 'root'): string {
    const buildXml = (data: any): string => {
      let xml = '';
      for (const prop in data) {
        if (Object.prototype.hasOwnProperty.call(data, prop)) {
          const value = data[prop];
          if (value === null || value === undefined) {
            xml += `<${prop}/>`;
          } else if (Array.isArray(value)) {
            xml += `<${prop}>`;
            value.forEach(item => {
              xml += `<data>${buildXml(item)}</data>`;
            });
            xml += `</${prop}>`;
          } else if (typeof value === 'object') {
            xml += `<${prop}>${buildXml(value)}</${prop}>`;
          } else {
            const safeVal = String(value)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/ formulation/g, '&gt;');
            xml += `<${prop}>${safeVal}</${prop}>`;
          }
        }
      }
      return xml;
    };
    this.applyZoom(); // Applica lo zoom dopo il rendering
    return `<?xml version="1.0" encoding="UTF-8"?><${rootName}>${buildXml(obj)}</${rootName}>`;
  }

  printDocument(): void {
    if (this.iframeArea?.nativeElement) {
      const iframe = this.iframeArea.nativeElement;
      const iframeWindow = iframe.contentWindow;

      if (iframeWindow) {
        const iframeDocument = iframe.contentDocument;
        const filename = this.template?.filename
          ? Helper.replaceKeyword(this.template.filename, this.source)
          : 'documento';
        const printTitle = filename.replace(/\.pdf$/i, ''); // Rimuove l'estensione .pdf se presente
        const previousTitle = document.title;  // Salva il titolo precedente del documento
        
        if (iframeDocument) {
          iframeDocument.title = printTitle;
        }

        // Mette a fuoco l'iframe ed esegue il comando di stampa nativo del browser
        document.title = printTitle; // Cambia il titolo del documento principale per la stampa
        try {
          iframeWindow.focus();
          iframeWindow.print();
        } finally {
          document.title = previousTitle; // ripristina il titolo precedente del documento dopo la stampa
          if (this.mode === 'modal' && this.modalWindow) {
            this.modalWindow.close();
          }
        }
      }
    }
  }

  async downloadPdf(): Promise<void> {
    const iframe = this.iframeArea.nativeElement;
    
    // Ottieni il document all'interno dell'iframe
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

    if (!iframeDocument || !iframeDocument.body) {
      console.error('Impossibile accedere al contenuto dell\'iframe');
      return;
    }

    const elementToCapture = iframeDocument.body;

    try {
      // 1. Converti l'HTML dell'iframe in una Canvas
      const canvas = await html2canvas(elementToCapture, {
        scale: 2,
        useCORS: true,
        allowTaint: true, // Consente l'uso di immagini cross-origin
        proxy: 'https://corsproxy.io/?', // Aggiunge un proxy CORS per recuperare le risorse
        logging: false
      });

      // 2. Calcola le dimensioni per la pagina A4
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // 3. Aggiungi la prima pagina
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // 4. Gestisci l'eventuale multi-pagina se il contenuto supera l'altezza di un A4
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      // 5. Avvia il download del file PDF
      let docname="documento.pdf";
      if(this.template.filename){        
        docname=Helper.replaceKeyword(this.template.filename,this.source);
      }

      pdf.save(docname);

    } catch (error) {
      console.error('Errore durante la generazione del PDF:', error);
    }
  }
}